import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UiAction from "../../components/UiAction.js";
import { faBan, faMinus, faPlus, faUnlock } from "@fortawesome/free-solid-svg-icons";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import uiManager from "../../../config/ui.js";
import BlockUnblockModal from "./BlockUnblockModal.js"
import ArchiveUnarchiveModal from "./ArchiveUnarchiveModal.js";

const Index = () => {
  const [showBlockUnblockModal, setShowBlockUnblockModal] = useState(false);
  const [showArchiveUnarchiveModal, setShowArchiveUnarchiveModal] = useState(false);
  const [operatorDetails, setOperatorDetails] = useState({});
  const defaultHeaderConfig = { disableSort: true };
  const params = useParams();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'operator_id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name'
    },
    {
      ...defaultHeaderConfig,
      label: 'Wallet Balance',
      attr: 'wallet_balance',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'Total Cash Collected',
      attr: 'total_cash_collected',
    },
    {
      ...defaultHeaderConfig,
      label: 'Distributor Firm',
      attr: 'distributor_firm_name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status'
    },
    {
      ...defaultHeaderConfig,
      label: 'Activation Date',
      attr: 'activated_at',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.block_unblock_operator.name)}>
          {
            row.active === false ?
            <div
              style={{cursor: 'pointer'}}
              className='link-info border rounded p-1 bg-info-subtle'
              onClick={(e) => onBlockOrUnblockClick(row)}
            >
              <FontAwesomeIcon icon={faUnlock}/> Unblock
            </div> :
            <div
              style={{cursor: 'pointer'}}
              className='link-danger border rounded p-1 bg-danger-subtle'
              onClick={(e) => onBlockOrUnblockClick(row)}
            >
              <FontAwesomeIcon icon={faBan}/> Block
            </div>
          }
        </UiAction>
        <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.archive_unarchive_operator.name)}>
          {
            row.archived === true ?
            <div
              style={{cursor: 'pointer'}}
              className='link-info border rounded p-1 bg-info-subtle'
              onClick={(e) => onArchiveOrUnarchiveClick(row)}
            >
              <FontAwesomeIcon icon={faPlus}/> Unarchive
            </div> :
            <div
              style={{cursor: 'pointer'}}
              className='link-danger border rounded p-1 bg-danger-subtle'
              onClick={(e) => onArchiveOrUnarchiveClick(row)}
            >
              <FontAwesomeIcon icon={faMinus}/> Archive
            </div>
          }
        </UiAction>
      </div>
      },
    },
  ]

  const onBlockOrUnblockClick = (data) => {
    setOperatorDetails(data);
    setShowBlockUnblockModal(true);
  }

  const onArchiveOrUnarchiveClick = (data) => {
    setOperatorDetails(data);
    setShowArchiveUnarchiveModal(true);
  }

  return <>
    <BlockUnblockModal
      showBlockUnblockModal={showBlockUnblockModal}
      setShowBlockUnblockModal={setShowBlockUnblockModal}
      operatorDetails={operatorDetails}
    />
    <ArchiveUnarchiveModal
      showArchiveUnarchiveModal={showArchiveUnarchiveModal}
      setShowArchiveUnarchiveModal={setShowArchiveUnarchiveModal}
      operatorDetails={operatorDetails}
    />
    <ListingComponent
      key={'PAGES.OperatorsListingPage.name'}
      listingMutation={getApi('operators')}
      className="operators-listing-page"
      contentHeading="Operators List - Results"
      headers={headers}
      recordsKey="opeartors"
      filtersModel= {{distributor_id: params.id}}
      searchBy={['Name']}
    />
  </>
};

export default Index;
